var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("PaymentPromiseDialog.title"),
        visible: _vm.visible,
        "before-close": _vm.handleClose,
        width: "480px"
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "dialog-footer" },
                [
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("cancel")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleConfirm }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.$t("confirm")) + "\n\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "el-form",
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("PaymentPromiseDialog.update_amount"),
                    prop: "amount"
                  }
                },
                [
                  _c(
                    "el-input",
                    {
                      attrs: { autocomplete: "off" },
                      model: {
                        value: _vm.form.amount,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "amount", $$v)
                        },
                        expression: "form.amount"
                      }
                    },
                    [_c("template", { slot: "prepend" }, [_vm._v("€")])],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "option" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "ml-4",
                      model: {
                        value: _vm.form.prolong,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "prolong", $$v)
                        },
                        expression: "form.prolong"
                      }
                    },
                    [
                      _c(
                        "el-radio",
                        { attrs: { label: false, size: "large" } },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("PaymentPromiseDialog.increase"))
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: {
                            disabled: !_vm.allowProlong,
                            label: true,
                            size: "large"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("PaymentPromiseDialog.prolong")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }